import { css } from "@emotion/react";
import { InputText, InputTextProps } from "primereact/inputtext";
import { forwardRef } from "react";

export default forwardRef<HTMLInputElement, InputTextProps & { css?: any }>(
  ({ css: cssProp, ...props }, ref) => (
    <InputText
      css={[
        css`
          width: 100%;
        `,
        cssProp
      ]}
      {...props}
      ref={ref}
    />
  )
);
